import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { activeViolationsTab, ALERT_BANNER_DEFAULT } from '../constants';
import {
  type AlertBannerState,
  type GlobalState,
  type SystemDataThemeType,
} from '../types';

const initialState: GlobalState = {
  dataTheme: null as SystemDataThemeType,
  globalDateFormat: 'MMM dd, yyyy',
  isGlobalLoading: true,
  isGlobalError: false,
  globalErrorReason: '',
  activeViolationsTab,
  mediaQueryValue: 0,
  alertBanner: ALERT_BANNER_DEFAULT,
  isReadOnlyAction: false,
};

const globalSlice = createSlice({
  name: 'aag/global',
  initialState,
  reducers: {
    setViolationsActiveTab: (state, action: PayloadAction<string>) => {
      state.activeViolationsTab = action.payload;
      state.isGlobalLoading = true;
    },
    setGlobalDateFormat: (state, action: PayloadAction<string>) => {
      state.globalDateFormat = action.payload;
    },
    setIsGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.isGlobalLoading = action.payload;
    },
    setGlobalError: (
      state,
      action: PayloadAction<{ state: boolean; reason?: string }>
    ) => {
      state.isGlobalError = action.payload.state;
      state.globalErrorReason = action.payload.reason ?? '';
    },
    updateScreenSize: (state, action: PayloadAction<number>) => {
      if (state.mediaQueryValue !== action.payload) {
        state.mediaQueryValue = action.payload;
      }
    },
    setGlobalAlertBanner: (state, action: PayloadAction<AlertBannerState>) => {
      state.alertBanner = action.payload;
    },
    setIsReadOnlyAction: (state, action: PayloadAction<boolean>) => {
      state.isReadOnlyAction = action.payload;
    },
    setDataTheme: (state, action: PayloadAction<SystemDataThemeType>) => {
      state.dataTheme = action.payload;
    },
  },
});

const { reducer: globalReducer, actions } = globalSlice;

export const globalActions = actions;

export default globalReducer;
